import React from 'react';
import { Link } from 'gatsby';
import {Grid, Header } from 'semantic-ui-react';
import ModalGalleyLayout from './ModalGalleryLayout';
import Media from 'react-media';

const SplitTextInRespondToDevice = ({ text }) => {
  return (
    <Media query="(max-width: 767px)">
      { (mobile) => (
        <Media query="(max-width: 990px)">
          { (tablet) => (
            mobile ? <React.Fragment> { `${text.slice(0, 200)}...` } </React.Fragment> :
            !mobile && tablet ? <React.Fragment> { `${text.slice(0, 300)}...` } </React.Fragment> :
            !mobile && !tablet && <React.Fragment> { `${text.slice(0, 400)}...` } </React.Fragment>
          )}
        </Media>
      )}
    </Media>
  );
}

const SectionImage = ({ image }) => {
  return (
    <Grid.Column computer={5} tablet={6} 
      className='centerImages'
    >
      <figure className={`figure__img ${image.alt}`}>
        <img src={image.source} alt={image.altAttr} className="projetImage" />
      </figure>
    </Grid.Column>
  )
}

const SectionTitle = ({ head }) => {
  return (
    <div className="sectionTitleWrapper">
      <div className="projectNber"> <span className="nber__"> { head.nber } </span> </div>
      <Header as="h3" textAlign="left" className="projectSectionTitle"> { head.title }</Header>
    </div>
  );
}

const SectionDescriptionAndButton = ({description, gallery}) => {
  return (
    <React.Fragment>
      <p className="paragraph sectionDescriptionProjet padded__text">
        <SplitTextInRespondToDevice text={description.text} />
        <Link to="/projets" className="lire__suite lire__suite-dark"> continue reading </Link>
      </p>
      <ModalGalleyLayout
        buttonTitle={description.textButton}
        buttonClass="btnBackground btnClass alignBtn"
        images={gallery}
      />
    </React.Fragment>  
  )
}

const SectionDescription = ({ obj, reversed }) => {
  return (
    <Grid.Column computer={7} tablet={8} textAlign="justified">
      <div className={`sectionProjectWrapper ${ reversed ? 'reversed__class' : ''}`}>
        <SectionTitle head={obj.head} />
        <SectionDescriptionAndButton gallery={obj.gallery} description={obj.description} />
      </div>
    </Grid.Column>
  );
}

const SectionProjetLayout = ({ reverseOrder, componentData }) => {
  const { objImage, objDescription } = componentData
  return (
    <React.Fragment>
      <Grid.Row className="project__row">

        { 
          reverseOrder ?
          ( <React.Fragment>
              <SectionImage image={objImage} />
              <SectionDescription reversed={reverseOrder} obj={objDescription} />
            </React.Fragment>  
          ) : (
            <React.Fragment>
              <SectionDescription reversed={reverseOrder} obj={objDescription} />
              <SectionImage image={objImage} />
            </React.Fragment>
          )
        }
     
      </Grid.Row>
    </React.Fragment>
  )
}

SectionProjetLayout.defaultProps = {
  reverseOrder: false
};

export default SectionProjetLayout;
